import React from 'react';

interface OwnerAvatarProps {
  name: string;
  size?: number;
  className?: string;
}

// Renkli gradient paletleri — sahipler için ayrı set (canlı, sıcak tonlar)
const GRADIENTS: [string, string][] = [
  ['#6B8A45', '#06b6d4'], // teal-cyan
  ['#8b5cf6', '#ec4899'], // mor-pembe
  ['#f59e0b', '#ef4444'], // amber-kırmızı
  ['#10b981', '#6B8A45'], // emerald-teal
  ['#3b82f6', '#8b5cf6'], // mavi-mor
  ['#f97316', '#ec4899'], // turuncu-pembe
  ['#06b6d4', '#3b82f6'], // cyan-mavi
  ['#ec4899', '#a855f7'], // pembe-mor
];

const hashString = (str: string): number => {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
};

const getInitials = (name: string): string => {
  if (!name) return '?';
  const parts = name.trim().split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const OwnerAvatar: React.FC<OwnerAvatarProps> = ({
  name,
  size = 48,
  className = '',
}) => {
  const palette = GRADIENTS[hashString(name || 'owner') % GRADIENTS.length];
  const initials = getInitials(name);
  const fontSize = size * 0.36;

  return (
    <div
      className={`relative flex items-center justify-center text-white font-bold shadow-md overflow-hidden ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.28,
        background: `linear-gradient(135deg, ${palette[0]} 0%, ${palette[1]} 100%)`,
        boxShadow: `0 4px 12px ${palette[1]}40`,
        fontSize,
        letterSpacing: '-0.02em',
      }}
    >
      <div
        className="absolute top-0 left-0 right-0 h-1/2 opacity-20"
        style={{
          background: 'linear-gradient(180deg, rgba(255,255,255,0.4) 0%, transparent 100%)',
        }}
      />
      <span className="relative">{initials}</span>
    </div>
  );
};

export default OwnerAvatar;
